import { Stack, StackProps, styled } from "@mui/material";

interface EditionsContainerProps extends StackProps {
  noPadding?: boolean;
}

export const EditionsContainer = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "noPadding"
})<EditionsContainerProps>(({ theme, noPadding }) => ({
  gap: "1rem",
  padding: noPadding ? "0" : "1rem 2.5rem",

  [theme.breakpoints.down("sm")]: {
    padding: noPadding ? "0" : "1rem"
  }
}));
